<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Text"><span class="char-style-override"><span class="calibre1"><img alt="16385.jpg" class="frame" src="Images/16385.jpg"/></span></span> </p>
<p class="Text1"> </p>
<p class="Text1"> </p>
<p class="Text1"> </p>
<p class="Text"><span class="char-style-override"><span class="calibre1"><img alt="16391.jpg" class="frame1" src="Images/16391.jpg"/></span></span> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// theJournal.vue?c15a98c8